@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faSliders"></fa-icon>
        <span>{{ 'OCR_OVERRIDE.TITLE' | translate }}</span>
      </h3>
      <button class="close-btn" type="button" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <p class="override-hint">
        {{ 'OCR_OVERRIDE.HINT' | translate: { name: baseConfig?.name || baseConfig?.key } }}
      </p>

      <form>
        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.LAYOUT_ANALYSIS' | translate }}</label>
          <select [(ngModel)]="form.layoutAnalysis" name="layoutAnalysis">
            <option value="">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.NONE' | translate }}</option>
            <option value="true">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.AZURE_DOCUMENT' | translate }} (true)</option>
            <option value="1">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.TABLE_TRANSFORMER' | translate }} (1)</option>
            <option value="2">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.TABLE_STRUCTURE' | translate }} (2)</option>
            <option value="3">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.OMR_V31' | translate }} (3)</option>
            <option value="4">{{ 'CONFIGURATIONS.FORM.OPTIONS.LAYOUT_ANALYSIS.OMR_V32' | translate }} (4)</option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.INPUT_TYPE' | translate }}</label>
          <select [(ngModel)]="form.inputType" name="inputType">
            <option value="path">{{ 'CONFIGURATIONS.FORM.OPTIONS.INPUT_TYPE.PATH' | translate }} (path)</option>
            <option value="base64">{{ 'CONFIGURATIONS.FORM.OPTIONS.INPUT_TYPE.BASE64' | translate }} (base64)</option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.OCR_TYPE' | translate }}</label>
          <select [(ngModel)]="form.ocrType" name="ocrType">
            <option value="azure">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE' | translate }} (azure)</option>
            <option value="azure4">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE4' | translate }} (azure4)</option>
            <option value="google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.GOOGLE' | translate }} (google)</option>
            <option value="paddle">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.PADDLE' | translate }} (paddle)</option>
            <option value="docling">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.DOCLING' | translate }} (docling)</option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.OUTPUT_TYPE' | translate }}</label>
          <select [(ngModel)]="form.outputType" name="outputType">
            <option value="azure">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE' | translate }} (azure)</option>
            <option value="azure4">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.AZURE4' | translate }} (azure4)</option>
            <option value="google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.GOOGLE' | translate }} (google)</option>
            <option value="paddle">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.PADDLE' | translate }} (paddle)</option>
            <option value="docling">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.DOCLING' | translate }} (docling)</option>
            <option value="raw_google">{{ 'CONFIGURATIONS.FORM.OPTIONS.ENGINE.RAW_GOOGLE' | translate }} (raw_google)</option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.TEXT_TYPE' | translate }}</label>
          <select [(ngModel)]="form.textType" name="textType">
            <option value="print">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.PRINT' | translate }} (print)</option>
            <option value="hand">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.HAND' | translate }} (hand)</option>
            <option value="mix">{{ 'CONFIGURATIONS.FORM.OPTIONS.TEXT_TYPE.MIX' | translate }} (mix)</option>
          </select>
        </div>

        <div class="form-checkbox">
          <input type="checkbox" [(ngModel)]="form.ocrCrop" name="ocrCrop">
          <label>{{ 'CONFIGURATIONS.FORM.OCR_CROP' | translate }}</label>
        </div>
        <div class="form-checkbox">
          <input type="checkbox" [(ngModel)]="form.autoCut" name="autoCut">
          <label>{{ 'CONFIGURATIONS.FORM.AUTO_CUT' | translate }}</label>
        </div>
        <div class="form-checkbox">
          <input type="checkbox" [(ngModel)]="form.enhanceDocument" name="enhanceDocument">
          <label>{{ 'CONFIGURATIONS.FORM.ENHANCE_DOCUMENT' | translate }}</label>
        </div>
        <div class="form-checkbox">
          <input type="checkbox" [(ngModel)]="form.sortOcr" name="sortOcr">
          <label>{{ 'CONFIGURATIONS.FORM.SORT_OCR' | translate }}</label>
        </div>

        <div class="form-group">
          <label>{{ 'CONFIGURATIONS.FORM.ADJUST_ROTATION' | translate }}</label>
          <select [(ngModel)]="form.adjustRotation" name="adjustRotation">
            <option value="">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.NONE' | translate }}</option>
            <option value="1">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.PADDLE' | translate }} (1)</option>
            <option value="2">{{ 'CONFIGURATIONS.FORM.OPTIONS.ADJUST_ROTATION.REDO_OCR' | translate }} (2)</option>
          </select>
        </div>

        <div class="form-checkbox">
          <input type="checkbox" [(ngModel)]="form.splitPdf" name="splitPdf">
          <label>{{ 'CONFIGURATIONS.FORM.SPLIT_PDF' | translate }}</label>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <app-button [text]="'OCR_OVERRIDE.RESTORE' | translate" variant="secondary" [icon]="faRotateLeft"
        (clicked)="restoreOriginal()">
      </app-button>
      <div class="footer-right">
        <app-button [text]="'EXECUTE_MODAL.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
        </app-button>
        <app-button [text]="'OCR_OVERRIDE.APPLY' | translate" variant="primary" [icon]="faCheck" (clicked)="onApply()">
        </app-button>
      </div>
    </div>
  </div>
</div>
}
